export default __webpack_public_path__ + "static/media/github-visual-editor.a1a6f1a9.png";